<!-- src/components/Navbar.vue -->
<template>
  <nav class="navbar-custom navbar navbar-expand-md navbar-dark bg-secondary">
			<div class="container">
				<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTop" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-icon"></span>
				</button>
				<div class="collapse navbar-collapse justify-content-end" id="navbarTop">
					<ul class="navbar-nav">
						<li
              v-for="(item, index) in menu"
              :key="index"
              class="nav-item"
            >
              <a :href="item.url" class="nav-link">{{ $t(`menu.navbarTop.${item.label}`) }}</a>
            </li>
          </ul>
				</div>
			</div>
		</nav>
</template>

<script>
  import system from "@/services/system.json";
  
  export default {
  name: "Navbar",
  data() {
    return {
      menu: system.navbarTop
    };
  }
};
</script>
